'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const StickyActionButtons = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (!isHydrated) return;

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHydrated]);

  if (!isHydrated || !isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col space-y-3">
      <Link
        href="/get-involved"
        className="w-14 h-14 rounded-full bg-accent text-accent-foreground shadow-glass hover:shadow-cta flex items-center justify-center transition-all duration-300 hover:scale-110 group backdrop-blur-sm"
        aria-label="Donate now"
      >
        <Icon name="HeartIcon" size={24} variant="solid" className="group-hover:scale-110 transition-transform duration-300" />
      </Link>
      <Link
        href="/get-involved"
        className="w-14 h-14 rounded-full bg-secondary text-secondary-foreground shadow-glass hover:shadow-cta flex items-center justify-center transition-all duration-300 hover:scale-110 group backdrop-blur-sm"
        aria-label="Volunteer with us"
      >
        <Icon name="UserPlusIcon" size={24} variant="solid" className="group-hover:scale-110 transition-transform duration-300" />
      </Link>
      <a
        href="https://wa.me/918758758778"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-glass hover:shadow-cta flex items-center justify-center transition-all duration-300 hover:scale-110 group backdrop-blur-sm"
        aria-label="Contact us on WhatsApp"
      >
        <Icon name="ChatBubbleLeftRightIcon" size={24} className="group-hover:scale-110 transition-transform duration-300" />
      </a>
    </div>
  );
};

export default StickyActionButtons;